export default __webpack_public_path__ + "static/media/W_Warima.4a7cf089.svg";